import cn from 'classnames';

import Text from 'components/common/Text';
import Tag from 'components/icons/Tag';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const FreeForLifeBanner = ({ text }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <div
      className={cn(
        'flex flex-row items-center gap-2 rounded-lg p-2',
        isTempo ? 'bg-tempo-blue-50' : 'bg-cream-100'
      )}
    >
      <Tag className="text-primary" />
      <Text
        htmlElement="span"
        className={cn('textSm font-medium', isTempo ? 'text-tempo-navy-100' : '')}
      >
        {text}
      </Text>
    </div>
  );
};

FreeForLifeBanner.propTypes = {
  text: PropTypes.string.isRequired,
};

export default FreeForLifeBanner;
